/**
 * Remove anonymous emails from display
 * @param {string} email The email
 * @returns {string} The email with anonymous emails removed
 */
export function removeAnonEmail(email: string) {
	if (email.startsWith('anon')) {
		return ' ';
	}
	return email;
}
